const getDevices = state => state.devices;

export default {
    getDevices,
}
